import React from "react";
import { Row } from "antd";
import ColorPicker from "../Common/ColorPicker";
import { useSelector, useDispatch } from "react-redux";
import { chatItemUpdated } from "store/actions/WebchatBrandingElementsAction";
import AssetUploader from "../Common/AssetUploader.js";
import updateStyling from "utility/PortalPostMessage";


export default function WebchatBrandingTabMenuChat() {
    const dispatch = useDispatch();
    const { previewState } = useSelector((state) => state.WebchatBrandingElementsReducer);

    const BRAND_MESSAGE_ICON_KEY = "brandMessageIcon";
    const BRAND_MESSAGE_BACKGROUND_COLOR_KEY = "brandMessageBackgroundColor";
    const BRAND_MESSAGE_TEXT_COLOR_KEY = "brandMessageTextColor";
    const CONTACT_MESSAGE_BACKGROUND_COLOR_KEY = "contactMessageBackgroundColor";
    const CONTACT_MESSAGE_TEXT_COLOR_KEY = "contactMessageTextColor";


    const onAssetUploadCallbackMessageIcon = (uploadedAssetUrl) => {
        if (uploadedAssetUrl === undefined) {
            return;
        }
        updateStyling(document, BRAND_MESSAGE_ICON_KEY, uploadedAssetUrl)
        dispatch(chatItemUpdated(BRAND_MESSAGE_ICON_KEY, uploadedAssetUrl));
    }

    return (
        <>
            <Row gutter={[10, 10]} style={{ marginLeft: 10 }}>
                <div style={{ marginTop: 20 }}>
                    <h3 style={{ marginBottom: 0, fontWeight: "bold" }}>Branding Message Icon</h3>
                    <AssetUploader currentIconUrl={previewState[BRAND_MESSAGE_ICON_KEY]} onAssetUploadCallback={onAssetUploadCallbackMessageIcon} />
                </div>
                <ColorPicker label="Message Background Color" initialValue={previewState[BRAND_MESSAGE_BACKGROUND_COLOR_KEY]} onChange={(color) => {
                    updateStyling(document, BRAND_MESSAGE_BACKGROUND_COLOR_KEY, color)
                    dispatch(chatItemUpdated(BRAND_MESSAGE_BACKGROUND_COLOR_KEY, color))
                }} />
                <ColorPicker label="Message Text Color" initialValue={previewState[BRAND_MESSAGE_TEXT_COLOR_KEY]} onChange={(color) => {
                    updateStyling(document, BRAND_MESSAGE_TEXT_COLOR_KEY, color)
                    dispatch(chatItemUpdated(BRAND_MESSAGE_TEXT_COLOR_KEY, color))
                }} />
                <ColorPicker label="Contact Message Background Color" initialValue={previewState[CONTACT_MESSAGE_BACKGROUND_COLOR_KEY]} onChange={(color) => {
                    updateStyling(document, CONTACT_MESSAGE_BACKGROUND_COLOR_KEY, color)
                    dispatch(chatItemUpdated(CONTACT_MESSAGE_BACKGROUND_COLOR_KEY, color))
                }} />
                <ColorPicker label="Contact Message Text Color" initialValue={previewState[CONTACT_MESSAGE_TEXT_COLOR_KEY]} onChange={(color) => {
                    updateStyling(document, CONTACT_MESSAGE_TEXT_COLOR_KEY, color)
                    dispatch(chatItemUpdated(CONTACT_MESSAGE_TEXT_COLOR_KEY, color))
                }} />
            </Row>
        </>
    );
}
